@if (configuration$ | async; as result) {
  <div class="editor-container" [class.dim-editor]="isLoading">
    @if (result.isLoading) {
      <div class="centered-content panel">
        <ngx-skeleton-loader count="7" appearance="line" />
      </div>
    }
    @if (result.isSuccess) {
      @if (isLoading) {
        <app-spinner class="spinner"></app-spinner>
      }
      @if (editorLockFailureResponse !== null) {
        <div class="no-lock-banner">
          <div [innerHtml]="'CALLS.EDITOR_LOCKED' | translate: { name: editorLockFailureResponse.user | userName }"></div>
          <button
            mat-raised-button
            (click)="forceUnlock()"
            translate="CALLS.EDITOR_FORCE_UNLOCK"
            [matTooltip]="'CALLS.EDITOR_FORCE_UNLOCK_TOOLTIP' | translate"
          ></button>
        </div>
      }
      @if (call.isPostProcessingComplete) {
        @if (call.isSpeechMissing) {
          <div class="centered-content panel">
            <h1>{{ 'CALLS.NO_SPEECH_MESSAGE' | translate }}</h1>
          </div>
        } @else {
          <div class="editor-wrapper" [style.display]="isEditorInitialized ? 'block' : 'none'">
            @if (!call.hasWarningForMissingAgendaBeenShown && !call.hasMinutes) {
              <div class="blurred-background">
                <div class="panel">
                  <div class="description" translate="CALLS.AGENDA_MISSING_WARNING"></div>
                  <div class="buttons">
                    <button mat-raised-button color="primary" (click)="uploadAgenda()" translate="CALLS.AGENDA_MISSING_WARNING_UPLOAD_BUTTON"></button>
                    <div translate="COMMON.OR"></div>
                    <button mat-raised-button color="secondary" (click)="approveMissingAgenda()" translate="CALLS.AGENDA_MISSING_WARNING_SKIP_BUTTON"></button>
                  </div>
                </div>
              </div>
            }
            <editor [cloudChannel]="'7'" [init]="init" [apiKey]="result.data.tinyMceApiKey" [(ngModel)]="call.editorContent"> </editor>
            @if (isEditorInitialized && editorSettingsService.showWordCount) {
              <mat-chip class="word-count-badge">
                <span class="word-count">{{ wordCount }}</span> {{ 'EDITOR.WORD_COUNT.LABEL' | translate }}
              </mat-chip>
            }
          </div>
          @if (!isEditorInitialized) {
            <div class="centered-content panel no-margin">
              <ngx-skeleton-loader count="7" appearance="line" />
            </div>
          }
        }
      } @else {
        <div class="centered-content panel">
          @if (call.isMinutesGenerationOngoing) {
            <h1>{{ 'CALLS.MINUTES_PROCESSING_MESSAGE' | translate }}</h1>
          } @else {
            <h1>{{ 'CALLS.MINUTES_WILL_BE_SHOWN_HERE' | translate }}</h1>
          }
        </div>
      }
    }
  </div>
}
